<template>
  <div class="page">
    <PageHeader>
      Города
    </PageHeader>
    <div class="content">
      <el-card
        shadow="always"
        class="main-card"
        v-loading="loading || loadingBasicCommission"
      >
        <div slot="header">
          <div>
            <el-form ref="form" :inline="true" size="normal">
              <el-form-item>
                <el-tooltip placement="top" content="Поиск по названию и коду">
                  <el-input
                    class="bottom-space"
                    prefix-icon="el-icon-search"
                    placeholder="Введите и нажмите Enter"
                    v-model="searchStringFilter"
                    @change="handleSearch"
                    clearable
                  >
                    <el-button slot="append" icon="el-icon-search"></el-button>
                  </el-input>
                </el-tooltip>
              </el-form-item>
              <el-form-item>
                <el-tooltip placement="top" content="Фильтр активности">
                  <el-select
                    class="bottom-space"
                    placeholder="Выберите активность"
                    clearable
                    filterable
                    v-model="isActiveFilter"
                    @change="handleSearch"
                  >
                    <el-option key="false" label="Нет" value="Нет"> </el-option>
                    <el-option key="true" label="Да" value="Да"> </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="bottom-space"
                  v-if="isFiltered"
                  type="danger"
                  @click="resetSearch"
                  >Сбросить фильтры</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div v-if="valuteCities.docs">
          <el-table
            :data="valuteCities.docs"
            @sort-change="handleSortChange"
            :default-sort="{ prop: '_id', order: 'descending' }"
            :row-class-name="tableRowClassName"
            border
            stripe
          >
            <el-table-column sortable="custom" prop="_id" label="ID" width="90">
              <template slot-scope="scope">
                <i v-if="scope.row.isNew" class="el-icon-document-add"></i>
                {{ scope.row._id.slice(-6) }}
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="name"
              label="Название"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="bestchangeCity"
              label="Код"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="bestchangeCityId"
              label="Bestchange Id"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="courierCommissionPercent"
              label="Комиссия за курьерскую доставку, множитель"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="courierCommissionAmount"
              label="Комиссия за курьерскую доставку, фикс"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="treasureCommissionPercent"
              label="Комиссия клада, множитель"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="treasureCommissionAmount"
              label="Комиссия за клад, фикс"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="minWithdrawalAmount"
              label="Минимальная сумма к выводу"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="hasOffice"
              label="Есть офис"
            >
              <template v-slot="scope">
                {{ scope.row.hasOffice ? "Да" : "Нет" }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="120"
              sortable="custom"
              prop="isActive"
              label="Активен?"
            >
              <template v-slot="scope">
                {{ scope.row.isActive ? "Да" : "Нет" }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="session.type <= 1"
              fixed="right"
              label="Действия"
              width="150"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="handleEditRow(scope.row)"
                ></el-button>
                <el-tooltip placement="top">
                  <div slot="content">Удалить</div>
                  <el-button
                    size="small"
                    icon="el-icon-delete"
                    @click="handleDeleteItem(scope.row._id)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handlePageChange"
            :current-page.sync="valuteCities.page"
            :page-size="valuteCities.limit"
            layout="sizes, prev, pager, next, jumper"
            :total="valuteCities.totalDocs"
          ></el-pagination>
          <el-drawer
            :title="`Редактируем строку`"
            :before-close="handleCloseEditPopup"
            :visible.sync="showEditRowPopup"
            direction="ltr"
            ref="editrowpopup"
          >
            <el-card shadow="always" :body-style="{ padding: '20px' }">
              <el-form
                :model="rowEdit"
                ref="form"
                label-width="400px"
                :inline="true"
                size="normal"
                v-if="rowEdit && basicCommission"
              >
                <el-form-item label="Название">
                  <el-input v-model="rowEdit.name"></el-input>
                </el-form-item>
                <el-form-item label="Код">
                  <el-input v-model="rowEdit.bestchangeCity"></el-input>
                </el-form-item>
                <el-form-item label="Bestchange Id">
                  <el-input v-model="rowEdit.bestchangeCityId"></el-input>
                </el-form-item>
                <el-form-item
                  label="Комиссия за курьерскую доставку, множитель"
                >
                  <el-input-number
                    v-model="rowEdit.courierCommissionPercent"
                    size="normal"
                    :min="0"
                    :max="100"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                </el-form-item>
                <el-form-item label="Комиссия за курьерскую доставку, фикс">
                  <el-input-number
                    v-model="rowEdit.courierCommissionAmount"
                    size="normal"
                    :min="0"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                </el-form-item>
                <el-form-item label="Комиссия клада, множитель">
                  <el-input-number
                    v-model="rowEdit.treasureCommissionPercent"
                    size="normal"
                    :min="0"
                    :max="100"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                </el-form-item>
                <el-form-item label="Комиссия за клад, фикс">
                  <el-input-number
                    v-model="rowEdit.treasureCommissionAmount"
                    size="normal"
                    :min="0"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                </el-form-item>
                <el-form-item label="Минимальная сумма к выводу">
                  <el-input-number
                    v-model="rowEdit.minWithdrawalAmount"
                    size="normal"
                    :min="0"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                </el-form-item>
                <el-form-item label="Есть офис">
                  <el-switch v-model="rowEdit.hasOffice"></el-switch>
                </el-form-item>
                <el-form-item label="Активен?">
                  <el-switch v-model="rowEdit.isActive"></el-switch>
                </el-form-item>
                <div class="small">
                  <span style="color: #909399"
                    >Для доставки валюты курьером используется коммиссия:</span
                  >
                  {{
                    rowEdit.courierCommissionPercent
                      ? printPercent(rowEdit.courierCommissionPercent)
                      : rowEdit.courierCommissionAmount
                      ? rowEdit.courierCommissionAmount + " (фикс.)"
                      : basicCommission.courierCommissionPercent
                      ? printPercent(basicCommission.courierCommissionPercent)
                      : basicCommission.courierCommissionAmount + " (фикс.)"
                  }}
                </div>
                <div class="small" style="padding-bottom: 10px">
                  <span style="color: #909399"
                    >Для доставки валюты через клад используется
                    коммиссия:</span
                  >
                  {{
                    rowEdit.treasureCommissionPercent
                      ? printPercent(rowEdit.treasureCommissionPercent)
                      : rowEdit.treasureCommissionAmount
                      ? rowEdit.treasureCommissionAmount + " (фикс.)"
                      : basicCommission.treasureCommissionPercent
                      ? printPercent(basicCommission.treasureCommissionPercent)
                      : basicCommission.treasureCommissionAmount + " (фикс.)"
                  }}
                </div>
                <div class="demo-drawer__footer">
                  <el-button @click="cancelRowEdit">Отмена</el-button>
                  <el-button
                    type="primary"
                    @click="handleUpdateRow"
                    :loading="loadingEditRow"
                    >{{
                      loadingEditRow ? "Сохраняю ..." : "Сохранить"
                    }}</el-button
                  >
                </div></el-form
              >
            </el-card>
          </el-drawer>
        </div>
        <el-collapse>
          <el-collapse-item name="1">
            <template slot="title">
              <i class="header-icon el-icon-plus"></i>
              Добавить город
            </template>
            <el-form
              :model="newValuteCity"
              ref="form"
              label-width="400px"
              :inline="false"
              size="normal"
              v-if="newValuteCity && basicCommission"
            >
              <el-form-item label="Название">
                <el-input v-model="newValuteCity.name"></el-input>
              </el-form-item>
              <el-form-item label="Код">
                <el-input v-model="newValuteCity.bestchangeCity"></el-input>
              </el-form-item>
              <el-form-item label="Комиссия за курьерскую доставку, множитель">
                <el-input-number
                  v-model="newValuteCity.courierCommissionPercent"
                  size="normal"
                  :min="0"
                  :max="100"
                  :controls="true"
                  controls-position="both"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="Комиссия за курьерскую доставку, фикс">
                <el-input-number
                  v-model="newValuteCity.courierCommissionAmount"
                  size="normal"
                  :min="0"
                  :controls="true"
                  controls-position="both"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="Комиссия клада, множитель">
                <el-input-number
                  v-model="newValuteCity.treasureCommissionPercent"
                  size="normal"
                  :min="0"
                  :max="100"
                  :controls="true"
                  controls-position="both"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="Комиссия за клад, фикс">
                <el-input-number
                  v-model="newValuteCity.treasureCommissionAmount"
                  size="normal"
                  :min="0"
                  :controls="true"
                  controls-position="both"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="Минимальная сумма к выводу">
                <el-input-number
                  v-model="newValuteCity.minWithdrawalAmount"
                  size="normal"
                  :min="0"
                  :controls="true"
                  controls-position="both"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="Есть офис">
                <el-switch v-model="newValuteCity.hasOffice"></el-switch>
              </el-form-item>
              <el-form-item label="Активен?">
                <el-switch v-model="newValuteCity.isActive"></el-switch>
              </el-form-item>
              <div>
                <span style="color: #909399"
                  >Для доставки валюты курьером используется коммиссия:</span
                >
                {{
                  newValuteCity.courierCommissionPercent
                    ? printPercent(newValuteCity.courierCommissionPercent)
                    : newValuteCity.courierCommissionAmount
                    ? newValuteCity.courierCommissionAmount + " (фикс.)"
                    : basicCommission.courierCommissionPercent
                    ? printPercent(basicCommission.courierCommissionPercent)
                    : basicCommission.courierCommissionAmount + " (фикс.)"
                }}
              </div>
              <div style="padding-bottom: 10px">
                <span style="color: #909399"
                  >Для доставки валюты через клад используется коммиссия:</span
                >
                {{
                  newValuteCity.treasureCommissionPercent
                    ? printPercent(newValuteCity.treasureCommissionPercent)
                    : newValuteCity.treasureCommissionAmount
                    ? newValuteCity.treasureCommissionAmount + " (фикс.)"
                    : basicCommission.treasureCommissionPercent
                    ? printPercent(basicCommission.treasureCommissionPercent)
                    : basicCommission.treasureCommissionAmount + " (фикс.)"
                }}
              </div>
              <el-form-item>
                <el-button type="primary" @click="addItem">Добавить</el-button>
                <el-button @click="resetForm">Очистить</el-button>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
        <el-collapse v-if="basicCommissionEdit">
          <el-collapse-item name="2">
            <template slot="title">
              <i class="header-icon el-icon-plus"></i>
              Редактировать базовую комиссию
            </template>
            <el-form
              :model="basicCommissionEdit"
              ref="form"
              label-width="400px"
              :inline="false"
              size="normal"
            >
              <el-form-item label="Комиссия за курьерскую доставку, множитель">
                <el-input-number
                  v-model="basicCommissionEdit.courierCommissionPercent"
                  size="normal"
                  :min="0"
                  :max="100"
                  :controls="true"
                  controls-position="both"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="Комиссия за курьерскую доставку, фикс">
                <el-input-number
                  v-model="basicCommissionEdit.courierCommissionAmount"
                  size="normal"
                  :min="0"
                  :controls="true"
                  controls-position="both"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="Комиссия клада, множитель">
                <el-input-number
                  v-model="basicCommissionEdit.treasureCommissionPercent"
                  size="normal"
                  :min="0"
                  :max="100"
                  :controls="true"
                  controls-position="both"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="Комиссия за клад, фикс">
                <el-input-number
                  v-model="basicCommissionEdit.treasureCommissionAmount"
                  size="normal"
                  :min="0"
                  :controls="true"
                  controls-position="both"
                >
                </el-input-number>
              </el-form-item>
              <div>
                <span style="color: #909399"
                  >Для доставки валюты курьером используется коммиссия:</span
                >
                {{
                  basicCommissionEdit.courierCommissionPercent
                    ? basicCommissionEdit.courierCommissionAmount
                      ? "-"
                      : printPercent(
                          basicCommissionEdit.courierCommissionPercent
                        )
                    : basicCommissionEdit.courierCommissionAmount
                    ? basicCommissionEdit.courierCommissionAmount + " (фикс.)"
                    : "-"
                }}
              </div>
              <div style="padding-bottom: 10px">
                <span style="color: #909399"
                  >Для доставки валюты через клад используется коммиссия:</span
                >
                {{
                  basicCommissionEdit.treasureCommissionPercent
                    ? basicCommissionEdit.treasureCommissionAmount
                      ? "-"
                      : printPercent(
                          basicCommissionEdit.treasureCommissionPercent
                        )
                    : basicCommissionEdit.treasureCommissionAmount
                    ? basicCommissionEdit.treasureCommissionAmount + " (фикс.)"
                    : "-"
                }}
              </div>
              <el-form-item>
                <el-button type="primary" @click="editBasicCommission">{{
                  loadingBasicCommission ? "Сохраняю ..." : "Сохранить"
                }}</el-button>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
  </div>
</template>
<script>
import {
  updateValuteCityRow,
  getValuteCities,
  getValuteCityBasicCommission,
  addValuteCity,
  deleteValuteCity
} from "@/api";
import { mapState, mapActions, mapGetters } from "vuex";
import PageHeader from "../../ui/PageHeader.vue";
export default {
  components: { PageHeader },
  name: "ValuteCitiesPage",
  data: () => ({
    loading: true,
    loadingBasicCommission: false,
    newValuteCity: {
      name: "",
      bestchangeCity: "",
      bestchangeCityId: null,
      courierCommissionPercent: 0,
      courierCommissionAmount: 0,
      treasureCommissionPercent: 0,
      treasureCommissionAmount: 0,
      minWithdrawalAmount: 0,
      isActive: true,
      hasOffice: false
    },
    basicCommission: null,
    basicCommissionEdit: null,
    valuteCities: [],
    rowEdit: {},
    loadingEditRow: false,
    showEditRowPopup: false,
    isActiveFilter: null,
    searchStringFilter: "",
    isFiltered: false,
    page: 1,
    limit: 10,
    sort: "-_id"
  }),
  computed: {
    ...mapState("auth", ["session"])
  },
  methods: {
    async handleUpdateRow() {
      this.loadingEditRow = true;
      const { data } = await updateValuteCityRow(this.rowEdit);
      if (data) {
        this.loadingEditRow = false;
      }
      await this.getValuteCities();
      this.showEditRowPopup = false;
    },
    cancelRowEdit() {
      this.rowEdit = {};
      this.loadingEditRow = false;
      this.showEditRowPopup = false;
    },
    printPercent(commissionPercent) {
      return ((commissionPercent - 1) * 100).toFixed(2) + "%";
    },
    handleEditRow(row) {
      this.rowEdit = { ...row };
      this.showEditRowPopup = true;
    },
    handleCloseEditPopup(done) {
      this.showEditRowPopup = false;
    },
    async searchQueryBuilder() {
      const queryBuilders = [];
      //
      if (!this.searchStringFilter && !this.isActiveFilter) {
        this.isFiltered = false;
        return {};
      }
      //
      if (this.searchStringFilter) {
        queryBuilders.push({
          $or: [
            {
              name: {
                $regex: `.*${this.searchStringFilter}.*`,
                $options: "i"
              }
            },
            {
              bestchangeCity: {
                $regex: `.*${this.searchStringFilter}.*`,
                $options: "i"
              }
            }
          ]
        });
      }
      //
      if (this.isActiveFilter) {
        queryBuilders.push({ isActive: this.isActiveFilter === "Да" });
      }
      //
      this.isFiltered = true;
      return { $and: queryBuilders };
    },
    async getValuteCities() {
      try {
        this.loading = true;
        const { data } = await getValuteCities({
          page: this.page,
          limit: this.limit,
          sort: this.sort,
          query: await this.searchQueryBuilder()
        });
        if (data.status) this.valuteCities = data.result;
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loading = false;
      }
    },
    async getValuteCityBasicCommission() {
      try {
        this.loadingBasicCommission = true;
        const { data } = await getValuteCityBasicCommission();
        if (data.status) {
          this.basicCommission = data.result;
          this.basicCommissionEdit = { ...this.basicCommission };
        }
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loadingBasicCommission = false;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    async handleDeleteItem(id) {
      let message = "Вы точно хотите удалить город?";
      try {
        await this.$confirm(message, "Внимание!", {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        });
        await deleteValuteCity(id);
        await this.getValuteCities();
        this.$message({
          type: "success",
          message: `Город успешно удален успешно удален`
        });
      } catch (error) {
        this.$message({
          type: "info",
          message: "Удаление отменено"
        });
      }
    },
    async handleSortChange(sortData) {
      this.sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      await this.getValuteCities();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getValuteCities();
    },
    async handleSearch() {
      this.page = 1;
      await this.getValuteCities();
    },
    async resetSearch() {
      this.page = 1;
      this.isActiveFilter = null;
      this.searchStringFilter = "";
      await this.getValuteCities();
    },
    resetForm() {
      this.newValuteCity = {
        name: "",
        bestchangeCity: "",
        bestchangeCityId: null,
        courierCommissionPercent: 0,
        courierCommissionAmount: 0,
        treasureCommissionPercent: 0,
        treasureCommissionAmount: 0,
        minWithdrawalAmount: 0,
        isActive: true
      };
    },
    async addItem() {
      try {
        const data = {
          ...this.newValuteCity
        };
        const resp = await addValuteCity(data);
        await this.getValuteCities();
        this.resetForm();
        return this.$notify.success({
          title: "Успех"
        });
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      }
    },
    async editBasicCommission() {
      try {
        this.loadingBasicCommission = true;
        const { data } = await updateValuteCityRow(this.basicCommissionEdit);
        if (data) {
          this.$notify.success({ title: "Успех" });
          this.basicCommission = { ...this.basicCommissionEdit };
          this.loadingBasicCommission = false;
        }
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
        this.loadingBasicCommission = false;
      }
    }
  },
  async mounted() {
    await this.getValuteCities();
    await this.getValuteCityBasicCommission();
  }
};
</script>
<style scoped>
.main-card {
  width: 100%;
  padding: 20px;
}

.main-card >>> .el-card__header {
  padding-bottom: 3px;
}

.main-card >>> .el-card__header input {
  margin-bottom: 0;
}

.main-card >>> .el-input {
  max-width: 300px;
}

.bottom-space {
  margin-bottom: 15px;
}

.el-form-item {
  margin-bottom: 0;
}

.content {
  display: flex;
  justify-content: space-between;
}

.el-pagination {
  padding: 15px 5px;
  margin-left: -10px;
}

.el-drawer__wrapper >>> .el-drawer {
  width: 750px !important;
}

.small {
  font-size: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ValuteCities/index.vue